import React from "react";

function SearchPageLoadingOverlay({ loading }) {
  return (
    <div className="loading-overlay" style={{ display: loading ? "block" : "none" }}>
      <div className="loading-container">
        <div className="loading-content">
          <div className="preloader"><div className="dot1" /><div className="dot2" /></div>
          <p className="direct">Loading</p>
        </div>
      </div>
    </div>
  );
}

export default SearchPageLoadingOverlay;
